"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _Field = require("../Field/Field.styles");

var field = function field(theme) {
  return /*#__PURE__*/(0, _react.css)("border:none;.ck-editor__editable_inline{min-height:auto;font-size:", theme.fontSize.large, ";line-height:", theme.lineHeight.leadingNormal, ";padding:0;overflow:hidden;border:0 solid transparent!important;border-width:", _Field.styles.fieldPadding, "!important;p{white-space:nowrap;margin:0!important;}>:last-of-type{margin-bottom:0px;}>:first-of-type{margin-top:0px;}}transition:border-color 0.3s;&:hover{border-color:", theme.color.primary.brand, "!important;}&+*{user-select:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:field;"));
};

var styles = {
  field: field
};
exports.styles = styles;
//# sourceMappingURL=FieldWithVariables.styles.js.map